
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as overview21fXdTJj_Mr9OULTEcdfESvh2SWhybUZ3dnqV6jHD4sMeta } from "/app/pages/overview.vue?macro=true";
import { default as partnerss9lBfNyvWm1ArfVYDNYaTZPixnScXy82e9acLeU4NuYMeta } from "/app/pages/partners.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as indexocwluAQFuMt263YxcUXV33K3IFvXRFwgQe4yEX0QSBYMeta } from "/app/pages/library/index.vue?macro=true";
import { default as _91id_93aYf1703Nu_wJzXdOkKDCvjmlckCT_OJuJaMXBPBOJ_gMeta } from "/app/pages/outreach/[id].vue?macro=true";
import { default as index8ZB15zuAQKzWYNBdrBto14a_U5Ube4ml7UmhxG_453FEoMeta } from "/app/pages/outreach/index.vue?macro=true";
import { default as _91id_93di8qdJdXcLSgEw9_FiyqSttFshe4_7VSFrICC4HBtq0Meta } from "/app/pages/negotiations/[id].vue?macro=true";
import { default as indexBz6WPb9m_45y6aHOPvypQ0g2dqlZxM_vzpwt5LlqZEbBAMeta } from "/app/pages/negotiations/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "overview",
    path: "/overview",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/overview.vue")
  },
  {
    name: "partners",
    path: "/partners",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "library",
    path: "/library",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/library/index.vue")
  },
  {
    name: "outreach-id",
    path: "/outreach/:id()",
    meta: { ...(_91id_93aYf1703Nu_wJzXdOkKDCvjmlckCT_OJuJaMXBPBOJ_gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/outreach/[id].vue")
  },
  {
    name: "outreach",
    path: "/outreach",
    meta: { ...(index8ZB15zuAQKzWYNBdrBto14a_U5Ube4ml7UmhxG_453FEoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/outreach/index.vue")
  },
  {
    name: "negotiations-id",
    path: "/negotiations/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/negotiations/[id].vue")
  },
  {
    name: "negotiations",
    path: "/negotiations",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/negotiations/index.vue")
  }
]